<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/inventory/goodsreceipt" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("inventory.label.Edit Goods Receipt") }}</h3>
          </li>
        </ul>
      </div>
      <ValidationObserver ref="observer">
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row">
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.Purchase Date") }}
                    <span class="required">*</span></small
                  >
                  <datepicker
                    :placeholder="$t('placeholder.label.SelectDate')"
                    v-model="good.purchaseDate"
                    class="mb-2 font-semibold"
                    disabled
                  />
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.Purchase No')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="good.purchaseNo"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.Supplier')"
                  class="w-full mb-5 font-semibold starlabel"
                  v-model="good.supplierName"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <vs-input
                  :label="$t('inventory.label.Office Id')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="good.officeName"
                  disabled
                />
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("inventory.label.Item Code") }}
                    <span class="required">*</span></small
                  >
                  <v-select
                    label="itemCode"
                    v-model="good.itemDescription"
                    :options="itemCodes"
                    :placeholder="$t('inventory.label.SelectCode')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2 font-semibold"
                    disabled
                  >
                    <!-- <template v-slot:option="option">{{
                  option.itemCode
                }}</template> -->
                  </v-select>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('inventory.label.Ordered Quantity')"
                >
                  <vs-input
                    :label="$t('inventory.label.Ordered Quantity')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="good.orderdQuantity"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <div class="saveCancelBtn mb-3">
            <vs-button type="border" class="" @click="backToGoods"
              >{{ $t("stockTransfer.label.Cancel") }}
            </vs-button>
            <vs-button class="" @click="createGRN">{{
              $t("inventory.label.Submit")
            }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import {
  getByIdGood,
  getBySupplerId,
  getGrnTemplate,
  getBySupplerdropdown,
  editGrnTemplate,
} from "@/http/inventory";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const goodEmptyObj = {
  purchaseDate: "",
  purchaseNo: "",
  supplierId: "",
  officeId: "",
  itemMasterId: "",
  orderdQuantity: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
};

export default {
  data() {
    return {
      good: goodEmptyObj,
      goods: {},
      items: {},
      itemCodes: [],
      dropdown: [],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      dateFormat: "dd MMMM yyyy",
      purchaseNo: "",
      itemCode: "",
      officeId: "",
      showItemCode: {},
      parentEntities: [],
      purchasedDate: moment().format("DD MMMM YYYY"),
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {},

  methods: {
    async getBySupplerdropdown() {
      try {
        const response = await getBySupplerdropdown(this.id);
        this.dropdown = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getGrnTemplate() {
      try {
        const response = await getGrnTemplate();
        this.template = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getBySupplerId() {
      try {
        const response = await getBySupplerId(this.id);
        this.itemCodes = response.data;
        let showItemCode = this.itemCodes.find((el) => (el.id = this.id));
        this.showItemCode = { ...showItemCode };
        this.good.itemCodes = response.data.itemCode;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getByIdGood() {
      try {
        const response = await getByIdGood(this.id);
        this.good = response.data;
        this.good.purchaseDate = Date(this.good.purchaseDate);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async createGRN() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.good = {
        itemMasterId: this.good.itemMasterId,
        locale: "en",
        // purchaseDate: this.good.purchaseDate,
        purchaseNo: this.good.purchaseNo,
        supplierId: this.good.supplierId,
        officeId: this.good.officeId,
        orderdQuantity: this.good.orderdQuantity,
        dateFormat: "dd MMMM yyyy",
      };
      console.log(this.good.purchaseDate);
      this.good.purchaseDate = moment(this.good.purchaseDate).format(
        "DD MMMM YYYY"
      );
      // this.goods.itemMasterId = this.goods.itemMasterId;
      try {
        const resp = await editGrnTemplate(this.id, this.good);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Good Receipt Edited Successfully!",
          type: "success",
        });
        if (resp.data.resourceId) {
          this.$router.push("/inventory/goodsreceipt");
          this.resetForm();
        }
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    resetForm() {
      this.goods.purchaseDate = "";
      this.goods.purchaseNo = "";
      this.goods.supplierId = "";
      this.goods.officeId = "";
      this.goods.itemCode = "";
      this.goods.orderdQuantity = "";
    },
    backToGoods() {
      this.$router.push("/inventory/goodsreceipt");
    },
  },
  watch: {},
  created() {
    this.getBySupplerdropdown();
    this.getGrnTemplate();
    this.id = this.$route.params.id;
    // this.getBySupplerId(this.id);
    this.getByIdGood();
  },
};
</script>
<style scoped>
.startred {
  color: red;
  font-size: 13px;
}
</style>
